export default __webpack_public_path__ + "static/media/clock-alarm.4c3ed5d8.svg";